/*
 *
 * Dashboard
 *
 */

import React from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { ContentWrapper, FleetDashboardMap } from "components"
import { Tabs, notification } from "antd"
import {
	setTitle,
	setLoader,
	setBreadcrumb,
	delayedDispatch,
	updateCrumb,
} from "store/actions"
import { API, Endpoints } from "utils/api"
import moment from "moment"
import Strings from "utils/strings"
import "./styles.scss"
import {
	listenToMessages,
	requestNotificationPermission,
} from "firebase/firebaseMessaging"

const { TabPane } = Tabs

export class Dashboard extends React.Component<any, any> {
	constructor(props: any) {
		super(props)

		this.state = {
			active: false,
			hasUnsavedFields: true,
			inStock: true,
			language: "pt",
			defaultBusinesses: [],
			selectedBusiness: null,
		}
	}

	async componentDidMount() {
		const { dispatch } = this.props

		dispatch(setTitle(Strings.sidebar.dashboard))

		await this.getInitialData()

		this.breadcrumb()
	}

	componentDidUpdate() {
		const { dispatch } = this.props
		dispatch(updateCrumb())
	}

	async getInitialData() {
		const { dispatch } = this.props

		dispatch(setLoader(true))

		let response: any
		try {
			response = await API.get({
				url: Endpoints.uriBusinesses("orders"),
			})

			if (response.ok) {
				const { businesses: defaultBusinesses } = response.data.results || {}
				this.setState({ defaultBusinesses })
			} else {
				notification.error({
					message: Strings.sidebar.orders,
					description:
						response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5,
				})
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5,
			})
		}

		dispatch(setLoader(false))
	}

	breadcrumb() {
		delayedDispatch(
			setBreadcrumb(() => {
				return {
					actions: [
						{
							type: "select",
							text: Strings.businesses.business,
							placeholder: Strings.orders.selectBusiness,
							value: this.state.selectedBusiness,
							options: this.state.defaultBusinesses.map((business: any) => ({
								value: business._id,
								text: business.name,
							})),
							onChange: (business: any) => {
								if (business !== this.state.selectedBusiness) {
									this.setState({
										selectedBusiness: business,
									})
								}
							},
							minWidth: 170,
							maxWidth: 170,
							allowClear: true,
						},
					],
				}
			})
		)
	}

	render() {
		const { selectedBusiness } = this.state

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.dashboard}</title>
					<meta name="description" content="Description of Dashboard" />
				</Helmet>
				<ContentWrapper
					extraStyle={{
						padding: 0,
						boxShadow: "none",
						backgroundColor: "transparent",
					}}
				>
					<div className="FleetDashboardContainer">
						<FleetDashboardMap
							businessId={selectedBusiness}
							mapContainerStyle={{ height: "calc(95vh - 120px)" }}
						/>
					</div>
				</ContentWrapper>
			</React.Fragment>
		)
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
})

export default connect(mapStateToProps)(Dashboard)
